module.exports = __webpack_public_path__ + "media/images/emblems/Bruegg-coat_of_arms-d3da3d4cd36949f3c454782f596ffcb4.svg";